/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Styled components
 */
export default styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
